import {
  useGetUserHomeworkIdeas,
  useDeleteHomeworkIdea,
  getGetUserHomeworkIdeasQueryKey,
  useGetTopHomeworkIdeas,
  likeHomeWorkIdea,
  unlikeHomeWorkIdea,
  getGetTopHomeworkIdeasQueryKey,
} from "@packages/api/madlenAPI";
import { HomeworkIdeaResponseDto } from "@packages/api/madlenAPI.schemas";
import { HomeworkIdeaCard } from "../../components/homework_ideas/HomeworkIdeaCard";
import GenericToolPage from "../../components/tool_components/GenericToolPage";

interface ExtendedHomeworkIdeaResponseDto extends HomeworkIdeaResponseDto {
  isEditable?: boolean;
}

const HomeworkIdeaDetailComponent = ({
  tool,
}: {
  tool: ExtendedHomeworkIdeaResponseDto;
}) => {
  return <HomeworkIdeaCard homeworkIdea={tool} isEditable={tool.isEditable} />;
};

const HomeworkIdeasView = () => {
  return (
    <GenericToolPage
      useGetTools={useGetUserHomeworkIdeas}
      useDeleteTool={useDeleteHomeworkIdea}
      getGetToolsQueryKey={getGetUserHomeworkIdeasQueryKey}
      useGetTopTools={useGetTopHomeworkIdeas}
      likeTool={likeHomeWorkIdea}
      unlikeTool={unlikeHomeWorkIdea}
      getGetTopToolsQueryKey={getGetTopHomeworkIdeasQueryKey}
      toolType="homeworkIdeas"
      toolPath="homework-ideas"
      DetailComponent={HomeworkIdeaDetailComponent}
      colors={{
        light: "from-lime-600 to-green-600",
        dark: "dark:from-lime-400 dark:to-green-400",
        iconBg: "bg-lime-100 dark:bg-lime-900/50",
        iconColor: "text-lime-600 dark:text-lime-400",
        hover: "hover:bg-lime-50 dark:hover:bg-lime-900/20",
      }}
      toolColor="lime"
      gradientColor="pink"
    />
  );
};

export default HomeworkIdeasView;
